import React, { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import useLanguages from "../hooks/useLanguages";

export function LanguageAutocomplete({ value, onChange }) {
  const { data: lanData, isLoading, isError, error } = useLanguages();
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([]);

  // Initialize options and selected value when data loads or value changes
  useEffect(() => {
    if (lanData) {
      setOptions(lanData);

      // Find the option that matches the current value (code)
      const selected = lanData.find((option) => option.code === value);
      setSelectedOption(selected || null);
    }
  }, [lanData, value]);

  const handleChange = (event, newValue) => {
    setSelectedOption(newValue);
    onChange(newValue ? newValue.code : null);
  };

  if (isError) {
    return <div>Error loading languages: {error.message}</div>;
  }

  return (
    <Autocomplete
      options={options}
      loading={isLoading}
      size="small"
      getOptionLabel={(option) => option.language}
      value={selectedOption}
      onChange={handleChange}
      isOptionEqualToValue={(option, value) => option.code === value.code}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select language"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
